import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  const displayCategories = categories.filter(c => c.slug !== 'all');

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            探索分类
          </h2>
          <p className="text-foreground-500 text-sm mt-3">
            按您喜欢的类型发现韩漫，总有一款适合您
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-secondary-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <span className="font-heading text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}